import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'sp-synchronize-style-toggle',
    templateUrl: './sp-synchronize-style-toggle.component.html',
    styleUrls: ['./sp-synchronize-style-toggle.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, TooltipModule, TranslateModule],
})
export class SpSynchronizeStyleToggleComponent {
    @Input() public active: boolean;
}
